var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTerraformModuleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11.041 5.688 9.912 5.031v10.073l-9.912-5.037zm11 5.031v10.073l9.917-5.037V5.688zM.047.068v10.068l9.912 5.036V5.104zm10.994 26.853 9.912 5.037V21.895l-9.912-5.036z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerraformModuleIcon);
export default __webpack_public_path__ + "static/media/terraform-module-icon.a66fb4d765017928dc3aed556c1f31ed.svg";
export { ForwardRef as ReactComponent };